export const HOURS_IN_DAY = 24;

export const UTC_TIME_OPTIONS = { timeZone: 'UTC' };

/** YYYY-MM-DD по UTC-календарю */
export const formatUTCDate = (date) => {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** Парсит YYYY-MM-DD или ISO-строку как полночь UTC */
export const parseUTCDate = (dateStr) => {
  const [y, m, d] = dateStr.split('T')[0].split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

export const isSameUTCDay = (a, b) =>
  a.getUTCFullYear() === b.getUTCFullYear()
  && a.getUTCMonth() === b.getUTCMonth()
  && a.getUTCDate() === b.getUTCDate();

export const getMondayOfWeekUTC = (date = new Date()) => {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const day = d.getUTCDay();
  const diff = d.getUTCDate() - day + (day === 0 ? -6 : 1);
  d.setUTCDate(diff);
  return d;
};

export const formatUTCDateTime = (date, options = {}) =>
  date.toLocaleString('ru-RU', { ...UTC_TIME_OPTIONS, ...options });

export const formatUTCTime = (date, options = {}) =>
  date.toLocaleTimeString('ru-RU', { ...UTC_TIME_OPTIONS, ...options });

export const formatHour = (hour) => `${String(hour).padStart(2, '0')}:00`;

export const formatHourRange = (startHour, endHour) =>
  `${formatHour(startHour)} – ${formatHour(endHour)}`;

export const hoursToSegments = (hours) => {
  if (!hours || hours.length === 0) return [];
  const sorted = [...new Set(hours)].sort((a, b) => a - b);
  const segments = [];
  let start = sorted[0];
  let prev = sorted[0];

  for (let i = 1; i < sorted.length; i += 1) {
    if (sorted[i] === prev + 1) {
      prev = sorted[i];
    } else {
      segments.push({ startHour: start, endHour: prev + 1 });
      start = sorted[i];
      prev = sorted[i];
    }
  }
  segments.push({ startHour: start, endHour: prev + 1 });
  return segments;
};

/** element — .schedule-day-grid (без шапки дня) */
export const getHourFromPointer = (clientY, element) => {
  const rect = element.getBoundingClientRect();
  if (rect.height <= 0) return 0;
  const y = clientY - rect.top;
  const ratio = Math.max(0, Math.min(1, y / rect.height));
  const hour = Math.floor(ratio * HOURS_IN_DAY);
  return Math.max(0, Math.min(HOURS_IN_DAY - 1, hour));
};

export const normalizeRange = (startHour, endHour) => {
  const start = Math.min(startHour, endHour);
  const end = Math.max(startHour, endHour) + 1;
  return { startHour: start, endHour: end };
};

export const segmentStyle = (startHour, endHour) => ({
  top: `${(startHour / HOURS_IN_DAY) * 100}%`,
  height: `${((endHour - startHour) / HOURS_IN_DAY) * 100}%`,
});

export const hourInRange = (hour, startHour, endHour) =>
  hour >= startHour && hour < endHour;

export const findSegmentAtHour = (segments, hour) =>
  segments.find((s) => hourInRange(hour, s.startHour, s.endHour));
